export const UserActionTypes = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  SESSION_EXPIRED: "SESSION_EXPIRED",
  CLEAR_SESSION_EXPIRED: "CLEAR_SESSION_EXPIRED",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  UPDATE_DISTROS: "UPDATE_DISTROS",
};
